<template>
    <div class="page gc">
        <SideMenu />

        <div class="page-content g9">
            <h2>Password</h2>

            <form v-on:submit="onSubmit" action="#" method="post" id="form">
                <FormBuilder :formData="formData" :formValue="memberPassword"></FormBuilder>

                <button class="right" v-bind:class="{ 'loading': isLoading }">Save</button>
            </form>

            <div class="modal show" v-if="showPasswordSuccess" v-on:click="onClosePasswordSuccess">
                <div class="modal-content">
                    <header>Password Changed<span title="Close"></span></header>
                    <article>
                        <template>
                            Your password has been successfully changed.
                        </template>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import API from "../../Api"
    import SideMenu from "../Components/SideMenuAccount.vue"
    import FormBuilder from "../Components/FormBuilder.vue"
    import { mapState } from 'vuex'

    export default {
        components: {
            SideMenu,
            FormBuilder
        },
        data: () => ({
            showPasswordSuccess: false,
            isLoading: false,
            memberPassword: {},
            formData: [
                {
                    title: "Update password",
                    grid: "grid-100w",
                    forms: [
                        {
                            type: "password",
                            label: "Current password",
                            placeholder: "Enter current password",
                            value: "currentPassword"
                        },{
                            type: "password",
                            label: "New password",
                            placeholder: "Enter new password",
                            value: "newPassword"
                        },{
                            type: "password",
                            label: "Verify new password",
                            placeholder: "Repeat new password",
                            value: "newPasswordAgain"
                        }
                    ]
                }
            ]
        }),
        methods: {
            onClosePasswordSuccess() {
                this.showPasswordSuccess = false;
                this.memberPassword = {};
            },
            validate() {
                var errors = [];

                if (this.memberPassword.currentPassword == null || this.memberPassword.currentPassword === "") {
                    errors.push("Current password cannot be empty.");
                }

                if (this.memberPassword.newPassword == null || this.memberPassword.newPassword === "") {
                    errors.push("New password cannot be empty.");
                }

                if (this.memberPassword.newPassword != this.memberPassword.newPasswordAgain) {
                    errors.push("New password does not match verified new password.");
                }

                return errors;
            },
            onSubmit (e) {
                e.preventDefault();

                var errors = this.validate();

                if (errors.length > 0) {
                    this.$store.state.error.data.type = "Please correct the following";
                    this.$store.state.error.data.message = errors;
                    this.$store.state.error.show = true;

                    return;
                }

                this.isLoading = true;

                API.post("member/updatepassword", {
                    currentPassword: this.memberPassword.currentPassword,
                    newPassword: this.memberPassword.newPassword
                }).then(() => {
                    this.showPasswordSuccess = true;
                }).finally(() => {
                    this.isLoading = false;
                })
            }
        }
    }
</script>
